import { PAGE_TYPE } from '@config/constants';
import {
  BasePageModel,
  basePageToLocal,
  FrameItem,
  FrameItemToLocal,
  ReferenceNode,
} from '@interface/index';


export enum FakeTypeCategory {
  ALL = 'ALL',
  INTENT = 'INTENT',
  COMPOSITE = 'COMPOSITE',
  ENTITY = 'ENTITY',
  DIALOG_ACT = 'DIALOG_ACT'
}

export interface FakeTypeInfo extends BasePageModel {
  kind: PAGE_TYPE;
  description: string;
  triggers: string[];
  dialogAct?: boolean;
  qualification: string;
  externalQualification: boolean;
  inheritedFrames: FrameItem[];
  masterSelf?: FakeTypeInfo;
}

export function fakeTypeInfoToLocal(data: any): FakeTypeInfo {
  return {
    ...basePageToLocal(data),
    kind: data.kind,
    description: data.description,
    triggers: data.triggers,
    qualification: data.qualification,
    externalQualification: data.external_qualification,
    dialogAct: data.dialog_act,
    inheritedFrames: data.inherited_frames
      && data.inherited_frames.map(FrameItemToLocal),
    masterSelf: data.master_self && fakeTypeInfoToLocal(data.master_self)
  };
}

export function fakeTypeInfoToServer(data: FakeTypeInfo) {
  return {
    id: data.id,
    name: data.name,
    comment: data.comment,
    description: data.description,
    qualification: data.qualification,
    external_qualification: data.externalQualification,
    triggers: data.triggers,
    dialog_act: data.dialogAct
  };
}

